/**
 * 站点联系方式统一配置
 * WhatsApp 为主联系方式（两个号码），邮箱为次
 * 修改这里即可全站生效
 */
export const contact = {
  // 主 WhatsApp 号码（国际格式，仅数字，用于 wa.me 链接 + 单号回退场景）
  whatsapp: '8615521122288',
  // 第二 WhatsApp 号码
  whatsapp2: '8613602487036',
  // 多个 WhatsApp 号码列表（浮动按钮 / 下拉菜单使用）
  whatsapps: [
    { number: '8615521122288', label: 'Sales 1', display: '+86 155 2112 2288' },
    { number: '8613602487036', label: 'Sales 2', display: '+86 136 0248 7036' }
  ],
  // 电话（展示用）
  phone: '+86 15521122288',
  // 邮箱（次要联系方式）
  email: 'hystagelight01@gmail.com',
  // 公司名
  company: 'Guangzhou Huayang Stage Lighting Equipment Co., Ltd.',
  // 地址
  address: 'Shimen Street, Baiyun District, Guangzhou',
  // 工作时间
  hours: '8:30 - 17:30 (UTC+8)',
  // 默认 WhatsApp 预填消息
  waDefaultText: "Hello, I'm interested in your stage lighting products. Could you please share more details?"
};

/**
 * 生成 wa.me 链接
 * @param {string} number WhatsApp 号码（仅数字），不传则用默认主号
 * @param {string} text 预填消息
 */
export function waLink(number, text) {
  const num = (number || '').replace(/[^\d]/g, '') || contact.whatsapp;
  const msg = text || contact.waDefaultText;
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
}

/**
 * 生成 mailto 链接
 */
export function mailLink(email, subject) {
  const e = email || contact.email;
  return subject ? `mailto:${e}?subject=${encodeURIComponent(subject)}` : `mailto:${e}`;
}

export default contact;
